import { IProjectSettings, ProjectSettingsAttribute } from './projectSettings.models';

export const getProjectSettingAttributeValue = (
  projectSettings: IProjectSettings[] | undefined,
  attribute: ProjectSettingsAttribute,
) => {
  return (projectSettings ?? []).find((s) => s.attribute === attribute)?.value;
};

export const isProjectSettingAttributeActive = (
  projectSettings: IProjectSettings[] | undefined,
  attribute: ProjectSettingsAttribute,
) => {
  const value = getProjectSettingAttributeValue(projectSettings, attribute);
  return !(value ?? '') ? false : value?.toLocaleLowerCase() !== 'false';
};
